<template>
  <WizardModal
    :hideFooter="false"
    :hideStepper="true"
    :hasCustomActionFooter="true"
    :hideBackButton="false"
    :currentStep="2"
    :singleData="modelDetails"
    :showHeaderInMobile="true"
    :hideTitleAndDescription="true"
    :contentOverflowHidden="true"
    :hideClose="true"
    @on-close="onClickBackButton"
    @on-back="onClickBackButton"
  >
    <template #content>
      <main
        class="tw-flex tw-flex-col tw-h-full tw-min-h-[unset] tw-justify-between !tw-mt-0 rmd:!tw-mt-4 tw-gap-4 tw-pt-0 tw-box-border"
      >
        <section
          class="tw-w-full tw-flex tw-flex-col tw-h-full tw-gap-4 rmd:!tw-gap-6 tw-px-2"
        >
          <div
            class="tw-rounded-[8px] tw-bg-[#F3F3F6] tw-py-5 tw-px-4 tw-box-border tw-flex tw-flex-col tw-items-start tw-gap-2"
          >
            <Text variant="h6" class="md:!tw-leading-[18px]"
              >Are you a Limited Company with more than 1 candidate?</Text
            >
            <Text variant="p" textWeight="500" class="md:!tw-leading-[18px]"
              >You can select more than 1 spot depending on your requirements
              and the spots available for the specific course dates below.
            </Text>
          </div>
          <div class="tw-flex tw-flex-col tw-gap-2 tw-w-full">
            <div
              v-if="isShowSelectCourse"
              class="tw-flex tw-flex-col tw-items-start tw-gap-2 tw-w-full"
            >
              <Text variant="h5" class="md:!tw-text-[14px]"
                >Select Course Date(s) & Location</Text
              >
              <InputField
                class="!tw-w-full"
                v-model="numberOfSelectedDates"
                append-inner-icon="mdi-chevron-down"
                @click="onToggleShowSelectDate"
                :disabled="isShowSelectDates && selectedDates.length"
                @input="debouncedFilterCourse"
              ></InputField>
            </div>
            <!-- select date if desktop -->
            <div
              class="desktop__date__selector tw-box-border tw-w-full tw-overflow-auto lg:tw-hidden"
              v-if="isShowSelectDates"
            >
              <div
                v-if="isLoadingDates"
                class="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center"
              >
                <CommonLoader
                  v-if="isLoadingDates"
                  :loading="isLoadingDates"
                  class="loader-container"
                />
              </div>
              <v-table
                v-if="!isLoadingDates && filteredCalendarAttributes.length"
                class="select-dates-table tw-rounded-[8px]"
                height="330px"
                fixed-header
              >
                <thead class="tw-whitespace-nowrap">
                  <tr>
                    <th class="text-left !tw-bg-[#F5F6F8]"></th>
                    <th class="text-left !tw-bg-[#F5F6F8]">
                      <Text
                        variant="h6"
                        textColor="rgba(12, 15, 74, 0.5)"
                        whiteSpace="nowrap"
                        textWeight="500"
                        >Start Date</Text
                      >
                    </th>
                    <th class="text-left !tw-bg-[#F5F6F8]">
                      <Text
                        variant="h6"
                        textColor="rgba(12, 15, 74, 0.5)"
                        whiteSpace="nowrap"
                        textWeight="500"
                        >Location</Text
                      >
                    </th>
                    <th class="text-left !tw-bg-[#F5F6F8]">
                      <Text
                        variant="h6"
                        textColor="rgba(12, 15, 74, 0.5)"
                        whiteSpace="nowrap"
                        textWeight="500"
                        >Spots Left</Text
                      >
                    </th>
                    <th class="text-left !tw-bg-[#F5F6F8]">
                      <Text
                        variant="h6"
                        textColor="rgba(12, 15, 74, 0.5)"
                        whiteSpace="nowrap"
                        textWeight="500"
                        >Time Left To Enroll</Text
                      >
                    </th>
                  </tr>
                </thead>

                <tbody class="tw-whitespace-nowrap">
                  <tr
                    v-for="item in filteredCalendarAttributes"
                    :key="item.name"
                  >
                    <td class="tw-whitespace-nowrap">
                      <div v-if="item.timeLeft !== TIME_LEFT_DONE">
                        <v-checkbox
                          color="#4B4BFF"
                          v-model="selectedDates"
                          :value="item"
                          ripple="false"
                        ></v-checkbox>
                      </div>
                    </td>
                    <td class="tw-whitespace-nowrap">
                      <!-- <Text variant="p" lineHeight="18px" whiteSpace="nowrap">{{
                        appFilters.formatToDate(item.startDate, "DD MMM YYYY")
                      }}</Text> -->
                      <div>
                        <div
                          v-for="(week, index) in item?.courseScheduleWeeks"
                          :key="index"
                          class="tw-text-[14px]"
                        >
                          <p class="tw-whitespace-nowrap">
                            <strong>Week {{ index + 1 }}:</strong>
                            {{ appFilters.formatToDate(week?.weekStartDate) }}
                            -
                            {{ appFilters.formatToDate(week?.weekEndDate) }}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td class="tw-whitespace-nowrap">
                      <Text
                        variant="p"
                        lineHeight="18px"
                        whiteSpace="nowrap"
                        textWeight="500"
                        >{{ item.townAndPostcode }}</Text
                      >
                    </td>
                    <td class="tw-whitespace-nowrap">
                      <Text
                        variant="p"
                        lineHeight="18px"
                        whiteSpace="nowrap"
                        textWeight="500"
                        >{{ item.spotsRemaining }}</Text
                      >
                    </td>
                    <td class="tw-whitespace-nowrap">
                      <Text
                        variant="p"
                        lineHeight="18px"
                        whiteSpace="nowrap"
                        textWeight="500"
                        >{{ item.timeLeft }}
                      </Text>
                    </td>
                  </tr>
                </tbody>
              </v-table>
              <div
                v-if="!isLoadingDates && !filteredCalendarAttributes.length"
                class="tw-w-full tw-h-[300px] tw-flex tw-flex-col tw-items-center tw-justify-center"
              >
                <Text>No courses available</Text>
              </div>
            </div>
            <!-- select date if mobile -->
            <div
              v-if="isShowSelectDates"
              class="mobile__date__selector tw-hidden lg:!tw-flex tw-rounded-[8px] tw-border-[1px] tw-overflow-hidden tw-h-auto tw-w-full tw-p-4 tw-box-border tw-border-solid tw-border-[rgba(12,15,74,0.1)] lg:tw-flex-col"
            >
              <template v-if="calendarAttributes.length">
                <div
                  v-for="item in calendarAttributes"
                  :key="item.name"
                  class="tw-w-full tw-border-b-solid-custom tw-pb-[6px] tw-box-border"
                >
                  <div class="tw-flex tw-gap-3 tw-items-start">
                    <div
                      v-if="item.timeLeft !== TIME_LEFT_DONE"
                      class="tw-w-[24px]"
                    >
                      <v-checkbox
                        class="custom_checkbox tw-mt-2"
                        v-model="selectedDates"
                        :value="item"
                        height="auto"
                      ></v-checkbox>
                    </div>
                    <div
                      class="tw-flex tw-gap-3 tw-items-start tw-justify-start tw-flex-col tw-w-full tw-max-w-full"
                    >
                      <div class="tw-w-full tw-max-w-full">
                        <Text
                          variant="p"
                          textColor="rgba(12, 15, 74, 0.5)"
                          textWeight="500"
                          lineHeight="18px"
                          whiteSpace="nowrap"
                        >
                          Course Dates
                        </Text>
                        <Text variant="p" lineHeight="18px">
                          <!-- {{
                          appFilters.formatToDate(item.startDate, "DD MMM YYYY")
                        }} -->

                          <div>
                            <div
                              v-for="(week, index) in item?.courseScheduleWeeks"
                              :key="index"
                              class="tw-text-[14px]"
                            >
                              <p class="tw-whitespace-nowrap tw-font-[500]">
                                <span class="tw-font-semibold"
                                  >Week {{ index + 1 }}:</span
                                >
                                {{
                                  appFilters.formatToDate(week?.weekStartDate)
                                }}
                                -
                                {{ appFilters.formatToDate(week?.weekEndDate) }}
                              </p>
                            </div>
                          </div>
                        </Text>
                      </div>
                      <div
                        class="tw-flex tw-justify-between tw-items-center tw-w-full tw-max-w-full"
                      >
                        <div class="tw-flex tw-flex-col">
                          <Text
                            variant="p"
                            textColor="rgba(12, 15, 74, 0.5)"
                            textWeight="500"
                            lineHeight="18px"
                            whiteSpace="nowrap"
                          >
                            Location
                          </Text>
                          <Text variant="p" lineHeight="18px">
                            {{ item.townAndPostcode }}
                          </Text>
                        </div>
                        <div class="tw-flex tw-flex-col">
                          <Text
                            variant="p"
                            textColor="rgba(12, 15, 74, 0.5)"
                            textWeight="500"
                            lineHeight="18px"
                            whiteSpace="nowrap"
                          >
                            Spots Left
                          </Text>
                          <Text
                            variant="p"
                            lineHeight="18px"
                            whiteSpace="nowrap"
                          >
                            {{ item.spotsRemaining }}
                          </Text>
                        </div>
                      </div>
                      <div class="tw-flex tw-flex-col tw-w-full tw-max-w-full">
                        <Text
                          variant="p"
                          textColor="rgba(12, 15, 74, 0.5)"
                          textWeight="500"
                          lineHeight="18px"
                          whiteSpace="nowrap"
                        >
                          Time Left To Enrol
                        </Text>
                        <Text variant="p" lineHeight="18px" whiteSpace="nowrap">
                          {{ item.timeLeft }}
                        </Text>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <div
                v-else
                class="tw-w-full tw-h-full tw-flex tw-flex-col tw-items-center tw-justify-center"
              >
                <Text>No courses available</Text>
              </div>
            </div>
            <!-- add spots in mobile -->
            <div
              v-if="isShowAddSpots"
              class="tw-w-full lg:tw-flex tw-flex-col tw-gap-4 tw-hidden"
            >
              <div
                class="!tw-flex tw-rounded-[8px] tw-border-[1px] tw-overflow-hidden tw-h-auto tw-w-full tw-p-[6px] tw-box-border tw-border-solid tw-border-[rgba(12,15,74,0.1)] tw-flex-col"
              >
                <template v-if="selectedDates && selectedDates.length">
                  <div
                    v-for="(item, index) in selectedDates"
                    :key="index"
                    class="tw-w-full tw-border-b-solid-custom tw-pb-[6px] tw-box-border"
                  >
                    <div
                      class="tw-flex tw-items-start tw-justify-between tw-flex-col tw-gap-2"
                    >
                      <div
                        class="tw-flex tw-justify-between tw-gap-1 tw-w-full tw-max-w-full"
                      >
                        <div class="tw-flex tw-flex-col">
                          <Text
                            variant="span"
                            textColor="rgba(12, 15, 74, 0.5)"
                            textWeight="400"
                            lineHeight="18px"
                            whiteSpace="nowrap"
                          >
                            Course Date
                          </Text>
                          <Text variant="span" lineHeight="18px">
                            {{
                              appFilters.formatToDate(
                                item.startDate,
                                "DD MMM YYYY"
                              )
                            }}
                          </Text>

                          <div>
                            <div
                              v-for="(week, index) in item.courseScheduleWeeks"
                              :key="index"
                              class="d-flex text-[14px]"
                            >
                              <p>
                                <strong>Week {{ index + 1 }}:</strong>
                                {{
                                  appFilters.formatToDate(
                                    week.weekStartDate,
                                    "DD MMM YYYY"
                                  )
                                }}
                                -
                                {{
                                  appFilters.formatToDate(
                                    week.weekEndDate,
                                    "DD MMM YYYY"
                                  )
                                }}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="tw-flex tw-flex-col">
                          <div class="tw-flex tw-items-center tw-justify-end">
                            <v-menu
                              transition="scale-transition"
                              location="start"
                            >
                              <template v-slot:activator="{ props }">
                                <Text
                                  v-bind="props"
                                  variant="16"
                                  class="tw-underline !tw-text-[#4F55F0] tw-cursor-pointer"
                                  >Remove</Text
                                >
                              </template>
                              <div
                                class="remove-popup tw-min-w-[389px] md:tw-min-w-[300px] tw-rounded-[8px] tw-bg-white tw-p-4 tw-flex tw-flex-col tw-items-start tw-gap-4"
                              >
                                <Text
                                  variant="h6"
                                  lineHeight="18px"
                                  textColor="rgba(12, 15, 74, 0.6)"
                                  >Are you sure you want to remove this
                                  spots?</Text
                                >
                                <div
                                  class="tw-w-full tw-flex tw-items-center tw-justify-end tw-gap-3"
                                >
                                  <Button
                                    class="!tw-w-auto"
                                    label="cancel"
                                    variant="secondary"
                                  ></Button>
                                  <Button
                                    class="!tw-w-auto"
                                    label="remove"
                                    @click="onRemoveReservation(index)"
                                  ></Button>
                                </div>
                              </div>
                            </v-menu>
                          </div>
                        </div>
                      </div>

                      <div
                        class="tw-flex tw-justify-between tw-gap-1 tw-w-full tw-max-w-full"
                      >
                        <div class="tw-flex tw-flex-col">
                          <Text
                            variant="span"
                            textColor="rgba(12, 15, 74, 0.5)"
                            textWeight="400"
                            lineHeight="18px"
                            whiteSpace="nowrap"
                          >
                            Spots
                          </Text>
                          <InputField
                            v-model="item.spots"
                            prepend-inner-icon="mdi-minus-box"
                            append-inner-icon="mdi-plus-box"
                            @click:append-inner="onIncrementSpot(index)"
                            @click:prepend-inner="onDecrementSpot(index)"
                          ></InputField>
                        </div>
                        <div class="tw-flex tw-flex-col tw-items-end">
                          <Text
                            variant="span"
                            textColor="rgba(12, 15, 74, 0.5)"
                            textWeight="400"
                            lineHeight="18px"
                            whiteSpace="nowrap"
                          >
                            Spots Remaining
                          </Text>
                          <Text
                            variant="span"
                            lineHeight="18px"
                            whiteSpace="nowrap"
                          >
                            {{ item.spotsRemaining }}
                          </Text>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
              <div
                class="tw-w-full tw-rounded-[8px] tw-bg-[#F3F3F6] tw-py-5 tw-px-4 tw-box-border tw-flex tw-flex-col tw-items-start tw-gap-2"
              >
                <div
                  class="tw-w-full tw-pb-4 tw-box-border tw-border-b-dashed-custom"
                >
                  <Text variant="h6"
                    >Total cost payable for 3 months based on the spots
                    selected</Text
                  >
                </div>

                <div class="tw-w-full tw-flex-row-between !tw-items-start">
                  <div class="tw-flex tw-flex-col tw-items-start">
                    <Text variant="h6">Spots</Text>
                    <Text
                      variant="span"
                      textWeight="400"
                      textColor="rgba(12, 15, 74, 0.5)"
                      >Total {{ numberOfSpotsReserved }} Spots (3 Months x
                      £9.99)</Text
                    >
                  </div>
                  <Text variant="h6">{{
                    CurrencyFilter.formatToCurrency(spotsAmount)
                  }}</Text>
                </div>

                <div class="tw-w-full tw-flex-row-between">
                  <Text variant="h6">VAT</Text>
                  <Text variant="h6">{{
                    CurrencyFilter.formatToCurrency(vatAmount)
                  }}</Text>
                </div>

                <div
                  class="tw-w-full tw-pt-4 tw-box-border tw-border-t-dashed-custom tw-flex-row-between"
                >
                  <Text variant="h6"
                    >Total Payable
                    <Text variant="span" textWeight="400"
                      >(Over 3 months)</Text
                    ></Text
                  >
                  <Text variant="h6" textColor="#FAA100">{{
                    CurrencyFilter.formatToCurrency(spotsAmount + vatAmount)
                  }}</Text>
                </div>
              </div>
            </div>
          </div>

          <!-- add spots in desktop -->
          <div
            v-if="isShowAddSpots"
            class="checked-column tw-flex tw-flex-col tw-gap-4 tw-items-start tw-w-full lg:tw-hidden"
          >
            <Text variant="h5" class="md:!tw-text-[14px]"
              >Select the number of spots you require for your selected
              dates?</Text
            >
            <div class="spots_selector tw-px-2 tw-pb-2 tw-box-border tw-w-full">
              <v-table class="select-dates-table tw-rounded-[8px]">
                <thead>
                  <tr>
                    <th class="text-left !tw-bg-[#F5F6F8]">
                      <Text
                        variant="p"
                        textColor="rgba(12, 15, 74, 0.5)"
                        whiteSpace="nowrap"
                        textWeight="500"
                        >Course Dates</Text
                      >
                    </th>
                    <th class="text-left !tw-bg-[#F5F6F8]">
                      <Text
                        variant="p"
                        textColor="rgba(12, 15, 74, 0.5)"
                        whiteSpace="nowrap"
                        textWeight="500"
                        >Spots</Text
                      >
                    </th>
                    <th class="text-left !tw-bg-[#F5F6F8]">
                      <Text
                        variant="p"
                        textColor="rgba(12, 15, 74, 0.5)"
                        whiteSpace="nowrap"
                        textWeight="500"
                        >Spots Remaining</Text
                      >
                    </th>
                    <th class="text-left !tw-bg-[#F5F6F8]"></th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="selectedDates && selectedDates.length"
                    ><tr v-for="(item, index) in selectedDates" :key="index">
                      <td>
                        <!-- <Text variant="p">{{
                          appFilters.formatToDate(item.startDate, "DD MMM YYYY")
                        }}</Text> -->
                        <div>
                          <div
                            v-for="(week, index) in item?.courseScheduleWeeks"
                            :key="index"
                            class="d-flex text-[14px]"
                          >
                            <p class="tw-whitespace-nowrap">
                              <strong>Week {{ index + 1 }}:</strong>
                              {{
                                appFilters.formatToDate(
                                  week.weekStartDate,
                                  "DD MMM YYYY"
                                )
                              }}
                              -
                              {{
                                appFilters.formatToDate(
                                  week.weekEndDate,
                                  "DD MMM YYYY"
                                )
                              }}
                            </p>
                          </div>
                        </div>
                      </td>
                      <td>
                        <InputField
                          v-model="item.spots"
                          prepend-inner-icon="mdi-minus-box"
                          append-inner-icon="mdi-plus-box"
                          @click:append-inner="onIncrementSpot(index)"
                          @click:prepend-inner="onDecrementSpot(index)"
                          class="tw-whitespace-nowrap tw-w-[100px]"
                        ></InputField>
                      </td>
                      <td>
                        <Text variant="h6" whiteSpace="nowrap">{{
                          item.spotsRemaining
                        }}</Text>
                      </td>
                      <td>
                        <div class="tw-flex tw-items-center tw-justify-end">
                          <v-menu
                            transition="scale-transition"
                            location="start"
                          >
                            <template v-slot:activator="{ props }">
                              <Text
                                v-bind="props"
                                variant="16"
                                class="tw-underline !tw-text-[#4F55F0] tw-cursor-pointer tw-text-[12px]"
                                whiteSpace="nowrap"
                                >Remove</Text
                              >
                            </template>
                            <div
                              class="remove-popup tw-min-w-[389px] md:tw-min-w-[300px] tw-rounded-[8px] tw-bg-white tw-p-4 tw-flex tw-flex-col tw-items-start tw-gap-4"
                            >
                              <Text
                                variant="h6"
                                lineHeight="18px"
                                textColor="rgba(12, 15, 74, 0.6)"
                                >Are you sure you want to remove this
                                spots?</Text
                              >
                              <div
                                class="tw-w-full tw-flex tw-items-center tw-justify-end tw-gap-3"
                              >
                                <Button
                                  class="!tw-w-auto"
                                  label="cancel"
                                  variant="secondary"
                                ></Button>
                                <Button
                                  class="!tw-w-auto"
                                  label="remove"
                                  @click="onRemoveReservation(index)"
                                ></Button>
                              </div>
                            </div>
                          </v-menu>
                        </div>
                      </td></tr
                  ></template>
                </tbody>
              </v-table>
            </div>

            <div
              class="tw-w-full tw-rounded-[8px] tw-bg-[#F3F3F6] tw-py-5 tw-px-4 tw-box-border tw-flex tw-flex-col tw-items-start tw-gap-2"
            >
              <div
                class="tw-w-full tw-pb-4 tw-box-border tw-border-b-dashed-custom"
              >
                <Text variant="h6"
                  >Total cost payable for 3 months based on the spots
                  selected</Text
                >
              </div>

              <div class="tw-w-full tw-flex-row-between !tw-items-start">
                <div class="tw-flex tw-flex-col tw-items-start">
                  <Text variant="h6">Spots</Text>
                  <Text
                    variant="span"
                    textWeight="400"
                    textColor="rgba(12, 15, 74, 0.5)"
                    >Total {{ numberOfSpotsReserved }} Spots (3 Months x
                    £9.99)</Text
                  >
                </div>
                <Text variant="h6">{{
                  CurrencyFilter.formatToCurrency(spotsAmount)
                }}</Text>
              </div>

              <div class="tw-w-full tw-flex-row-between">
                <Text variant="h6">VAT</Text>
                <Text variant="h6">{{
                  CurrencyFilter.formatToCurrency(vatAmount)
                }}</Text>
              </div>

              <div
                class="tw-w-full tw-pt-4 tw-box-border tw-border-t-dashed-custom tw-flex-row-between"
              >
                <Text variant="h6"
                  >Total Payable
                  <Text variant="span" textWeight="400"
                    >(Over 3 months)</Text
                  ></Text
                >
                <Text variant="h6" textColor="#FAA100">{{
                  CurrencyFilter.formatToCurrency(spotsAmount + vatAmount)
                }}</Text>
              </div>
            </div>
          </div>
        </section>
      </main>
    </template>
    <template #footer-action>
      <section
        class="tw-flex !tw-pb-8 tw-items-center tw-justify-center tw-flex-col tw-w-full tw-gap-4 md:!tw-gap-[8px]"
      >
        <Button
          label="continue"
          @click="onContinue"
          :disabled="
            !selectedDates.length || (isShowAddSpots && !allDateHasSpots)
          "
        />
      </section>
    </template>
  </WizardModal>
</template>
<script setup>
import moment from "moment";
import {
  computed,
  ref,
  onBeforeMount,
  onBeforeUnmount,
  watch,
  onMounted,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";

// import CommonDialog from "@/core/components/CommonDialog.vue";
import WizardModal from "@/core/components/modals/WizardModal.vue";
import Button from "@/core/components/ui/general/Button.vue";
import CheckGreen from "@/core/components/icons/CheckGreen.vue";
import CancelIcon from "@/core/components/icons/CancelIcon.vue";
import ListIcon from "@/core/components/icons/ListIcon.vue";
import Text from "@/core/components/ui/general/Text.vue";
import ChipState from "@/core/components/common/ChipState.vue";
import { COURSES_STORE } from "@/store/modules/courses";
import { TRADE_PASSPOSRT_ROUTE } from "@/modules/trade-passport/routes";
import { WORKSTATION } from "@/store/modules/workstation";
import { DASHBOARD_ROUTE } from "@/modules/dashboard/routes";
import InputField from "@/core/components/common/InputField.vue";
import CommonLoader from "@/core/components/CommonLoader.vue";
import appFilters from "@/filters";
import CurrencyFilter from "@/filters/currency.filter";
import debounce from "lodash/debounce";

const store = useStore();
const route = useRoute();
const router = useRouter();
const isShowSelectCourse = ref(true);
const courseId = ref(null);
const props = defineProps({
  selectedSchedule: { type: Object, default: null },
});

const emits = defineEmits(["on-close", "on-continue"]);

const TIME_LEFT_DONE = ref("Enrollment period has ended");

const isLoading = ref(false);
const isShowSelectDates = ref(false);

const selectedDates = ref([]);
const numberOfSelectedDates = ref("");

const isShowAddSpots = ref(false);
const spotPrice = ref(29.97); // 1 spot = 9.99 subscription * 3 months plan
const vat = ref(0.2);

const modelDetails = ref({
  id: 2,
  tab: "reserveSpot",
  name: "reserveSpot",
  header: "Air Source Heat Pump (Level 3)",
});

const isLoadingDates = ref(false);
const selectedAddress = ref([]);
const addressListFromCourse = ref([]);
const courseSchedules = ref([]);
const calendarAttributes = ref([]);
const filteredCalendarAttributes = ref([]);

const courseDetails = computed(
  () => store.getters[`${COURSES_STORE}/courseDetails`]
);

const selectedDatesStore = computed(
  () => store.getters[`${COURSES_STORE}/selectedDates`]
);

const totalReserveSpotAmount = computed(
  () => store.getters[`${COURSES_STORE}/totalReserveSpotAmount`]
);

const allDateHasSpots = computed(() => {
  return selectedDates.value.every((item) => item.spots > 0);
});

const spotsAmount = computed(() => {
  // Sum all spots in selectedDates
  const totalSpots = selectedDates.value.reduce((sum, item) => {
    return sum + item.spots;
  }, 0);

  // Multiply the sum by 29.97
  return totalSpots * spotPrice.value;
});

const vatAmount = computed(() => {
  return spotsAmount.value * vat.value;
});

const filterCourse = () => {
  if (selectedDates.value && selectedDates.value.length) {
    return;
  }
  isLoadingDates.value = true;
  // Filter the calendarAttributes by the selected address
  const filteredAttributes = calendarAttributes.value.filter((attribute) => {
    // Check if the address in the calendarAttributes matches the selected address (case-insensitive)
    return attribute.address
      .toLowerCase()
      .includes(numberOfSelectedDates.value.toLowerCase());
  });
  filteredCalendarAttributes.value = filteredAttributes;
  isLoadingDates.value = false;
};

const debouncedFilterCourse = debounce(filterCourse, 300);

const onClickBackButton = () => {
  return emits("on-close");
};

// const onCreateWorkstation = () => {
//   onClickBackButton();
//   store.dispatch(`${WORKSTATION}/setWsModal`, {
//     isShowWorkStationModal: true,
//   });
//   router.push({ name: DASHBOARD_ROUTE });
// };

const onToggleShowSelectDate = () => {
  // if searching always show the selected dates ui
  if (!selectedDates.value.length && numberOfSelectedDates.value !== "") {
    isShowSelectDates.value = true;
    return;
  }
  // if navigating back to selectDates from add spots screen
  if (
    !isShowSelectDates.value &&
    selectedDates.value &&
    selectedDates.value.length
  ) {
    const newSelectedDates = [];
    // Iterate through calendarAttributes
    calendarAttributes.value.forEach((item) => {
      // Check if the selectedDates contains an item with the same ID as in calendarAttributes
      const isSelected = selectedDates.value.find(
        (selectedItem) => selectedItem.id === item.id
      );

      // If it's selected, pre-check the checkbox by pushing it to newSelectedDates
      if (isSelected) {
        newSelectedDates.push(item);
      }
    });
    // set the newSelectedDates to selectedDates
    selectedDates.value = newSelectedDates;
  }
  isShowSelectDates.value = !isShowSelectDates.value;

  // make sure add spots section is close if select dates is open
  if (isShowSelectDates.value) {
    isShowAddSpots.value = false;
  }
};

const onContinue = async () => {
  if (isShowAddSpots.value) {
    // open terms and conditions modal
    await store.dispatch(
      `${COURSES_STORE}/setSelectedDates`,
      selectedDates.value
    );
    await store.dispatch(
      `${COURSES_STORE}/setTotalReserveSpotAmount`,
      spotsAmount.value + vatAmount.value
    );
    const currentDate = new Date();
    await store.dispatch(
      `${COURSES_STORE}/setSpotReservedDateStarted`,
      currentDate
    );
    emits("on-continue");
    return;
  }
  onToggleShowSelectDate();
  if (selectedDates.value && selectedDates.value.length) {
    selectedDates.value = selectedDates.value.map((date) => {
      return {
        ...date,
        spotsRemaining: date.spotsRemaining - 1,
        spots: 1,
      };
    });
  }

  isShowAddSpots.value = true;
};

const getCourseSchedule = async () => {
  try {
    courseId.value = route?.params.courseId;
    isLoadingDates.value = true;
    console.log(courseDetails.value?.name, "courseDetails.value?.name");
    let courseName = "";
    if (
      !courseDetails.value?.name ||
      courseDetails.value?.name === undefined ||
      courseDetails.value?.name === "undefined"
    ) {
      if (courseId.value === "1") {
        courseName = "Air Source Heat Pump Level 3";
      } else {
        courseName = "Green Skills";
      }
    } else {
      courseName = courseDetails.value?.name;
    }
    let response = await store.dispatch(`${COURSES_STORE}/getCourseSchedule`, {
      name: courseName,
    });

    // const currentDate = moment().format("YYYY-MM-DD");
    // const filteredData = response.data.filter((course) => {
    //   const enrollStart = moment(course.enrollmentStartDate, "YYYY-MM-DD");
    //   const enrollEnd = moment(course.enrollmentEndDate, "YYYY-MM-DD");

    //   // Check if the current date is between or equal to the enrollment start and end dates
    //   return (
    //     moment(currentDate).isSameOrAfter(enrollStart) &&
    //     moment(currentDate).isSameOrBefore(enrollEnd)
    //   );
    // });
    const today = moment().startOf("day");
    const filteredData = response.data.filter((schedule) => {
      return moment(schedule.startDate).isSameOrAfter(today);
    });
    courseSchedules.value = filteredData;
    addressListFromCourse.value = courseSchedules.value
      .filter((item) => item.address !== null)
      .map((item) => {
        return {
          address: item.address,
          id: item.id,
        };
      });
    selectedAddress.value = addressListFromCourse.value;
    if (courseSchedules.value) {
      calendarAttributes.value = await getCalenderAttribute();
    }
  } catch (error) {
    console.log("error:", error);
  } finally {
    console.log(calendarAttributes.value, "calendarAttributesssss");
    filteredCalendarAttributes.value = calendarAttributes.value;
    isLoadingDates.value = false;
  }
};

// Function to calculate time left
const calculateTimeLeft = async (enrollmentEndDate) => {
  // Check if enrollmentEndDate is null or invalid
  if (!enrollmentEndDate || isNaN(new Date(enrollmentEndDate).getTime())) {
    return "Invalid or missing enrollment end date";
  }

  const now = new Date(); // Current date
  const enrollmentEnd = new Date(enrollmentEndDate); // Enrollment end date

  const timeLeft = enrollmentEnd.getTime() - now.getTime(); // Time difference in milliseconds

  if (timeLeft <= 0) {
    return "Enrollment period has ended";
  }

  // Time calculations in milliseconds
  const msInDay = 24 * 60 * 60 * 1000;
  const msInHour = 60 * 60 * 1000;
  const msInMinute = 60 * 1000;
  const msInSecond = 1000;

  // Calculate remaining time in different units
  const daysLeft = Math.floor(timeLeft / msInDay);
  const hoursLeft = Math.floor((timeLeft % msInDay) / msInHour);
  const minutesLeft = Math.floor((timeLeft % msInHour) / msInMinute);
  const secondsLeft = Math.floor((timeLeft % msInMinute) / msInSecond);

  // Return days and hours together if applicable
  if (daysLeft >= 1) {
    return `${daysLeft} ${daysLeft > 1 ? "Days" : "Day"}, ${hoursLeft} ${
      hoursLeft > 1 ? "Hours" : "Hour"
    }`;
  } else if (hoursLeft >= 1) {
    return `${hoursLeft} ${hoursLeft > 1 ? "Hours" : "Hour"}`;
  } else if (minutesLeft >= 1) {
    return `${minutesLeft} ${minutesLeft > 1 ? "Minutes" : "Minute"}`;
  } else {
    return `${secondsLeft} ${secondsLeft > 1 ? "Seconds" : "Second"}`;
  }
};

const fetchLearnersCount = async (scheduleId) => {
  try {
    const response = await store.dispatch(
      `${COURSES_STORE}/getCourseScheduleById`,
      {
        courseScheduleId: scheduleId,
      }
    );
    const { course } = response;

    const { userCourses } = course;

    if (userCourses.length) {
      let users = [];
      userCourses.forEach((userCourse) => {
        const { userCourseSchedules, user } = userCourse;

        if (userCourseSchedules.length) {
          const item = userCourseSchedules.find((userCourseSchedule) => {
            return userCourseSchedule?.courseSchedule?.id === scheduleId;
          });
          if (item) {
            users.push(user);
          }
        }
      });
      return users.length;
    }

    return 0;
  } catch (error) {
    console.error(
      `Failed to fetch learners count for course ${scheduleId}:`,
      error
    );
    return 0; // Default to 0 if there's an error
  }
};

const getSpotRemaining = async (spotLimit, allotedSpot) => {
  // const enrolledLearnersCount = await fetchLearnersCount(scheduleId); // depracated. Use allotedSpot instead
  let spots;
  if (allotedSpot >= spotLimit) {
    spots = 0;
  } else {
    spots = spotLimit - allotedSpot;
  }
  return spots;
};

const getTownPostCode = async (fullAddress) => {
  // Split the string by commas and trim any extra whitespace
  const parts = fullAddress.split(",").map((part) => part.trim());
  // Return the last two parts joined by a comma and space
  return parts.slice(-2).join(", ");
};

const getCalenderAttribute = async () => {
  if (selectedAddress.value.length) {
    const selectedIds = selectedAddress.value.map((item) => item.id);

    const filteredCourseSchedulesByAddress = courseSchedules.value.filter(
      (schedule) => selectedIds.includes(schedule.id)
    );

    const results = await Promise.all(
      filteredCourseSchedulesByAddress.map(async (course) => ({
        ...course,
        spotsRemaining: await getSpotRemaining(
          course.spotLimit,
          course.allotedSpot
        ),
        timeLeft: await calculateTimeLeft(course.enrollmentEndDate),
        townAndPostcode: await getTownPostCode(course.address),
        dates: new Date(course?.startDate),
      }))
    );

    return results;
  }

  const results = await Promise.all(
    courseSchedules.value.map(async (course) => ({
      ...course,
      spotsRemaining: await getSpotRemaining(
        course.spotLimit,
        course.allotedSpot
      ),
      // timeLeft: await calculateTimeLeft(course.startDate, course.duration),
      dates: new Date(course?.startDate),
    }))
  );

  return results;
};

const numberOfSpotsReserved = computed(() => {
  // Sum all spots in selectedDates
  let totalSpots = 0;
  if (selectedDates.value && selectedDates.value.length) {
    totalSpots = selectedDates.value.reduce((sum, item) => {
      return sum + item.spots;
    }, 0);
  }

  return totalSpots;
});

const onIncrementSpot = (index) => {
  if (selectedDates.value[index].spotsRemaining) {
    selectedDates.value[index].spots++;
    selectedDates.value[index].spotsRemaining--;
  }
};
const onDecrementSpot = (index) => {
  if (selectedDates.value[index].spots > 1) {
    selectedDates.value[index].spots--;
    selectedDates.value[index].spotsRemaining++;
  }
};
const onRemoveReservation = (index) => {
  selectedDates.value.splice(index, 1); // Removes the reservation
};

watch(
  () => selectedDates.value.length,
  () => {
    console.log(selectedDates.value, "selectedDates");
    if (selectedDates.value.length) {
      numberOfSelectedDates.value = `${selectedDates.value.length} Date${
        selectedDates.value.length > 1 ? "s" : ""
      } Selected`;
    } else {
      numberOfSelectedDates.value = "";
    }
  },
  { deep: true }
);

watch(
  () => numberOfSelectedDates.value,
  () => {
    if (!selectedDates.value.length && numberOfSelectedDates.value !== "") {
      isShowSelectDates.value = true;
    }
  },
  { deep: true }
);

onBeforeMount(async () => {
  courseId.value = route?.params.courseId;
  if (courseId.value === "1") {
    modelDetails.value = {
      id: 2,
      tab: "reserveSpot",
      name: "reserveSpot",
      header: "Air Source Heat Pump (Level 3)",
    };
  } else {
    modelDetails.value = {
      id: 2,
      tab: "reserveSpot",
      name: "reserveSpot",
      header: "Solar PV, Battery Storage & EV Charging Level 3",
    };
  }
  await getCourseSchedule();
  if (props.selectedSchedule) {
    selectedDates.value = [props.selectedSchedule];
    onContinue();
    isShowSelectDates.value = false;
    isShowSelectCourse.value = false;
  }
});

onBeforeUnmount(() => {
  //   eligibility.value = null;
});
</script>
<style lang="scss" scoped>
.select-dates-table {
  box-shadow: 0px 4px 8px 0px rgba(12, 15, 74, 0.08);
  width: 100%;
}

.remove-popup {
  box-shadow: 0px 0px 21px 0px rgba(12, 15, 74, 0.24);
}

.select-dates-table {
  tbody {
    height: 100%;
    overflow: auto;
  }
}

.custom_checkbox {
  :deep(.v-input__control) {
    .v-selection-control {
      min-height: auto;
      .v-selection-control__wrapper {
        width: 16px;
        height: 16px;
        .v-selection-control__input {
          width: 16px;
          height: 16px;
        }
      }
    }
  }
}
</style>
